/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CodeEntry from "../../datatypeComponents/CodeEntry";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../../datatypeComponents/MarkdownEntry";
import PositiveIntEntry from "../../datatypeComponents/PositiveIntEntry";
import StringEntry from "../../datatypeComponents/StringEntry";
import UnsignedIntEntry from "../../datatypeComponents/UnsignedIntEntry";
import { Button, Dropdown, Modal, Table } from "semantic-ui-react";
import PeriodEntry, { displayStringFromFHIRPeriod } from "../../datatypeComponents/PeriodEntry";
import { displayStringFromFHIRRelativeTime } from "../../datatypeComponents/RelativeTimeEntry";
import RangeEntry, { displayStringFromFHIRRange } from "../../datatypeComponents/RangeEntry";
import QuantityEntry, { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept, displayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import UriEntry, { DisplayFromFHIRUri } from "../../datatypeComponents/UriEntry";
import ExpressionEntry, { DisplayFromFHIRExpression, displayStringFromFHIRExpression } from "../../datatypeComponents/ExpressionEntry";
import ReferenceEntry, { DisplayFromFHIRReference, displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";
import BooleanEntry, { displayStringFromFHIRBoolean } from "../../datatypeComponents/BooleanEntry";
import DatatypeSelector from "../../datatypeComponents/DatatypeSelector";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import GroupCriteriaStarter from "./GroupCriteriaStarter";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResourceChanges } from "../../slices/resourceChangeReport/resourceChangeReportSlice";
import { resourceUpdated, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import updateChangeReport from "../../slices/resourceChangeReport/updateChangeReport";
import updateElement, { updateNarrativeElement } from "../../functions/updateElement";
import NarrativeEntry from "../../datatypeComponents/NarrativeEntry";
import generateNarrativeForGroupResource from "../generateNarrativeFunctions/generateNarrativeForGroupResource";
import GroupCriteriaConverter from "./GroupCriteriaConverter";

const DeleteCharacteristicRowButton = ({ criteriaType, setGroupCharacteristicsState, index, characteristicString }) => {
    return (
        <Modal
            trigger={<span className={"unselectable"}
                style={{ cursor: "pointer", fontWeight: "normal", fontSize: "42px" }}
                title="Remove this entire row">🗑</span>}
            header='Are you sure you want to delete the Characteristic Row?'
            centered={false}
            content={<div style={{ paddingLeft: "20px" }}>
                {characteristicString && <span><b>Delete: </b><span style={{ whiteSpace: "pre-wrap" }}>{characteristicString}</span></span>}
            </div>}
            actions={[
                {
                    key: 'delete',
                    positive: false,
                    content: 'Delete',
                    onClick: () => {
                        if (criteriaType.toLowerCase() === "inclusion") {
                            setGroupCharacteristicsState(prevState => {
                                let inclusionCriteria = [...prevState.groupInclusionCharacteristics];
                                inclusionCriteria.splice(index, 1); //deleting the item from the array
                                return { ...prevState, groupInclusionCharacteristics: inclusionCriteria };
                            })
                        }
                        if (criteriaType.toLowerCase() === "exclusion") {
                            setGroupCharacteristicsState(prevState => {
                                let exclusionCriteria = [...prevState.groupExclusionCharacteristics];
                                exclusionCriteria.splice(index, 1);
                                return { ...prevState, groupExclusionCharacteristics: exclusionCriteria };
                            })
                        }
                    }
                },
                {
                    key: 'done',
                    content: 'Close',
                    negative: true
                }
            ]}
        />
    )
}

const RelativeTimeModal = ({ startingValue, relativeTimeModalState, setCharacteristicState, setRelativeTimeModalState }) => {
    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <Button style={{ padding: "6px", position: "absolute", right: "14px" }} className="formButton negative"
            content="✖"
            onClick={() => {
                setRelativeTimeModalState(prevState => { return { ...prevState, modalOpen: false }; });
            }} />
        <ArrayEntry datatype='RelativeTime' elementName='timing'
            fieldLabel='Timing' deletable={true} deletableArray={true} startCollapsed
            startingValue={startingValue}
            setResourceState={setCharacteristicState} />
        <br /><br />
        <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
            content="Submit" positive
            onClick={() => {
                setRelativeTimeModalState(prevState => { return { ...prevState, contentChanged: true, modalOpen: false }; });
            }}
        />
        <br />
    </div>;
    return (
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={relativeTimeModalState?.modalOpen}
            centered={false}
            content={modalContent}
        />
    )
}

const characteristicDotDeterminerReferenceResourceTypes = ['Practitioner', 'PractitionerRole', 'Organization', 'Device', 'DeviceDefinition'];
const characteristicOffsetValueSet = [{
    "system": "http://hl7.org/fhir/characteristic-offset",
    "code": "UNL",
    "display": "Upper Normal Limit"
}, {
    "system": "http://hl7.org/fhir/characteristic-offset",
    "code": "LNL",
    "display": "Lower Normal Limit"
}];
const characteristicDotInstancesAllowedDatatypes = ['unsignedInt', 'Range'];
const characteristicDotDurationAllowedDatatypes = ['Duration', 'Range'];
const codeableConceptLevelValueSet = [
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "397669002",
            "display": "Age"
        }]
    },
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "260905004",
            "display": "Condition"
        }]
    },
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "64572001",
            "display": "Disease (disorder)"
        }]
    },
    {
        "coding": [
            {
                "system": "http://snomed.info/sct",
                "code": "71388002",
                "display": "Procedure (procedure)"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/fhir-types",
                "code": "MedicationRequest",
                "display": "MedicationRequest"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/fhir-types",
                "code": "Observation",
                "display": "Observation"
            }
        ]
    },
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "263495000",
            "display": "Gender"
        }]
    },
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "103579009",
            "display": "Race"
        }]
    },
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "186034007",
            "display": "Ethnicity / related nationality data"
        }]
    },
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "246112005",
            "display": "Severity"
        }]
    },
    {
        "coding": [{
            "system": "http://snomed.info/sct",
            "code": "305335007",
            "display": "Admission to establishment (procedure)"
        }]
    },
    {
        "text": "Defined by CodeableConcept"
    },
    {
        "text": "Defined by Expression"
    },
    {
        "text": "Defined by Reference"
    },
    {
        "text": "Eligibility Criteria"
    },
    {
        "text": "Member of"
    },
    {
        "text": "Research Study (Participation in)"
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "39156-5",
                "display": "Body mass index (BMI) [Ratio]"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "2089-1",
                "display": "Cholesterol in LDL [Mass/volume] in Serum or Plasma"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "2160-0",
                "display": "Creatinine [Mass/volume] in Serum or Plasma"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "8462-4",
                "display": "Diastolic blood pressure"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "59261-8",
                "display": "Hemoglobin A1c/Hemoglobin.total in Blood"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "718-7",
                "display": "Hemoglobin [Mass/volume] in Blood"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "8480-6",
                "display": "Systolic blood pressure"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://loinc.org",
                "code": "20152-5",
                "display": "Volume expired during 1.0 s of forced expiration/Predicted"
            }
        ]
    }
];
const codeableConceptLevelValueSetDictionary = {
    "64572001": [ //Disease (disorder)
        {
            "coding": [{ system: "http://snomed.info/sct", code: "840539006", display: "COVID-19" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "840544004", display: "Suspected COVID-19" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "64779008", display: "Coagulopathy" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "371039008", display: "Thromboembolic disorder" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "236423003", display: "Impaired renal function" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "44054006", display: "Diabetes mellitus type 2 (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "703136005", display: "Diabetes mellitus in remission (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "35489007", display: "Depressive disorder (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "57054005", display: "Acute myocardial infarction (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "422504002", display: "Ischemic stroke (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "22298006", display: "Myocardial infarction (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "394659003", display: "Acute coronary syndrome (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "230690007", display: "Cerebrovascular accident (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "59282003", display: "Pulmonary embolism (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "64156001", display: "Thrombophlebitis (disorder)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "363346000", display: "Malignant neoplastic disease (disorder)" }]
        }
    ],
    "260905004": [ //Condition
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "77386006", display: "Pregnant (finding)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "236423003", display: "Impaired renal function" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "419620001", display: "Death (event)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "305450004", display: "Under care of doctor (finding)" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "395100000", display: "No evidence of cancer found (situation)" }]
        }
    ],
    "246112005": [ //Severity
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "255604002", display: "Mild" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "6736007", display: "Moderate" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "24484000", display: "Severe" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "371923003", display: "Mild to moderate" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "371924009", display: "Moderate to severe" }]
        },
        {
            "coding": [
                { system: "http://snomed.info/sct", code: "442452003", display: "Life threatening severity" }]
        }
    ],
    "305335007": [ //Admission to establishment (procedure)
        {
            "coding": [{ system: "http://snomed.info/sct", code: "32485007", display: "Hospital admission" }]
        }
    ],
    "397669002": [ //Age
        {
            "coding": [{ system: "https://www.nlm.nih.gov/mesh", code: "D007223", display: "Infant" }]
        },
        {
            "coding": [
                { system: "https://www.nlm.nih.gov/mesh", code: "D002648", display: "Child" }]
        },
        {
            "coding": [
                { system: "https://www.nlm.nih.gov/mesh", code: "D000293", display: "Adolescent" }]
        },
        {
            "coding": [
                { system: "https://www.nlm.nih.gov/mesh", code: "D000328", display: "Adult" }]
        }
    ],
    "71388002": [ // Procedure (procedure)
        {
            "coding": [{ system: "http://snomed.info/sct", code: "81266008", display: "Heart revascularization (procedure)" }]
        }
    ],
    "MedicationRequest": [
        {
            "coding": [{ system: "http://www.nlm.nih.gov/research/umls/rxnorm", code: "2284960", display: "Remdesivir 100 mg Injection" }]
        }
    ],
    "Observation": [
        {
            "coding": [{
                "system": "http://loinc.org",
                "code": "39156-5",
                "display": "Body mass index (BMI) [Ratio]"
            }]
        },
        {
            "coding": [
                {
                    "system": "http://loinc.org",
                    "code": "2089-1",
                    "display": "Cholesterol in LDL [Mass/volume] in Serum or Plasma"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://loinc.org",
                    "code": "2160-0",
                    "display": "Creatinine [Mass/volume] in Serum or Plasma"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://loinc.org",
                    "code": "8462-4",
                    "display": "Diastolic blood pressure"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://loinc.org",
                    "code": "59261-8",
                    "display": "Hemoglobin A1c/Hemoglobin.total in Blood"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://loinc.org",
                    "code": "718-7",
                    "display": "Hemoglobin [Mass/volume] in Blood"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://loinc.org",
                    "code": "8480-6",
                    "display": "Systolic blood pressure"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://loinc.org",
                    "code": "20152-5",
                    "display": "Volume expired during 1.0 s of forced expiration/Predicted"
                }]
        }
    ],
    "263495000": [ // Gender
        {
            "coding": [
                {
                    "system": "http://hl7.org/fhir/administrative-gender",
                    "code": "male",
                    "display": "Male"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://hl7.org/fhir/administrative-gender",
                    "code": "female",
                    "display": "Female"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://hl7.org/fhir/administrative-gender",
                    "code": "other",
                    "display": "Other"
                }]
        },
        {
            "coding": [
                {
                    "system": "http://hl7.org/fhir/administrative-gender",
                    "code": "unknown",
                    "display": "Unknown"
                }]
        }
    ],
    "103579009": [ // Race
        {
            "coding": [{ system: "urn:oid:2.16.840.1.113883.6.238", code: "1002-5", display: "American Indian or Alaska Native" }]
        },
        {
            "coding": [
                { system: "urn:oid:2.16.840.1.113883.6.238", code: "2028-9", display: "Asian" }]
        },
        {
            "coding": [
                { system: "urn:oid:2.16.840.1.113883.6.238", code: "2054-5", display: "Black or African American" }]
        },
        {
            "coding": [
                { system: "urn:oid:2.16.840.1.113883.6.238", code: "2076-8", display: "Native Hawaiian or Other Pacific Islander" }]
        },
        {
            "coding": [
                { system: "urn:oid:2.16.840.1.113883.6.238", code: "2106-3", display: "White" }]
        },
        {
            "coding": [
                { system: "urn:oid:2.16.840.1.113883.6.238", code: "2131-1", display: "Other Race" }]
        },
        {
            "coding": [
                { system: "http://terminology.hl7.org/CodeSystem/v3-NullFlavor", code: "ASKU", display: "asked but unknown" }]
        },
        {
            "coding": [
                { system: "http://terminology.hl7.org/CodeSystem/v3-NullFlavor", code: "UNK", display: "unknown" }]
        }
    ],
    "186034007": [ // Ethnicity / related nationality data
        {
            "coding": [
                { system: "http://terminology.hl7.org/CodeSystem/v3-Ethnicity", code: "2135-2", display: "Hispanic or Latino" }]
        },
        {
            "coding": [
                { system: "http://terminology.hl7.org/CodeSystem/v3-Ethnicity", code: "2137-8", display: "Spaniard" }]
        }
    ]
};

const valueCodeableConceptSystemChoices = [
    { 'uri': 'http://snomed.info/sct', 'display': 'SNOMED CT' },
    { 'uri': 'http://hl7.org/fhir/sid/icd-10', 'display': 'ICD-10' },
    { 'uri': 'http://loinc.org', 'display': 'LOINC' },
    { 'uri': 'http://www.nlm.nih.gov/research/umls/rxnorm', 'display': 'RxNorm' },
    { 'uri': 'https://www.whocc.no/atc_ddd_index/', 'display': 'ATC' },
    { 'uri': 'http://unitsofmeasure.org', 'display': 'UCUM' },
    { 'uri': 'https://www.nlm.nih.gov/mesh', 'display': 'MeSH' },
    { 'uri': 'https://fevir.net/sevco', 'display': 'SEVCO' }
];

const EnhancedCharacteristicTableRow = ({ characteristic, index, setGroupCharacteristicsState, criteriaType,
    editMode, setCharacteristicArrayState }) => {
    let cJson = characteristic || {};
    let characteristicForumlaDisplay = "";
    let characteristicDeterminerDisplay = "";
    let methodDisplay = "";
    if (cJson.formula && Object.keys(cJson.formula).length > 0) {
        characteristicForumlaDisplay = displayStringFromFHIRExpression(cJson.formula);
    }
    if (cJson.determiner && Object.keys(cJson.determiner).length > 0) {
        characteristicDeterminerDisplay = displayStringFromFHIRReference(cJson.determiner);
    }
    if (cJson.method?.length > 0) {
        methodDisplay = cJson.method.map(item => {
            return displayStringFromFHIRCodeableConcept(item)
        }).join('; ');
    }

    const [characteristicState, setCharacteristicState] = useState({});
    const [systemChoicesState, setSystemChoicesState] = useState(valueCodeableConceptSystemChoices);
    const [typeSpecificCodeableConceptLevelValueSetState, setTypeSpecificCodeableConceptLevelValueSetState] = useState([]);
    const [characteristicCodeDisplay, setCharacteristicCodeDisplay] = useState("");
    const [determinedByOpenState, setDeterminedByOpenState] = useState(false);
    const [characteristicValueDatatypeState, setCharacteristicValueDatatypeState] = useState('none');
    const [chooseValueDataTypeState, setChooseValueDatatypeState] = useState(true);
    const [valuePickListState, setValuePickListState] = useState([]);
    const [instancesDatatypeState, setInstancesDatatypeState] = useState('none');
    const [instancesOpenState, setInstancesOpenState] = useState(false);
    const [durationDatatypeState, setDurationDatatypeState] = useState('none');
    const [durationOpenState, setDurationOpenState] = useState(false);
    const [relativeTimeModalState, setRelativeTimeModalState] = useState({ "modalOpen": false });
    const [ageEntryState, setAgeEntryState] = useState(false);
    const [eligibilityCriteriaEntryState, setEligibilityCriteriaEntryState] = useState(false);

    useEffect(() => {
        let cJson = characteristic || {};
        let startingCharacteristicState = {
            "characteristicJson": cJson, "extension": cJson.extension || [],
            "description": cJson.description || "", "code": cJson.code || "", "method": cJson.method || [],
            "formula": cJson.formula || cJson.determinedByExpression || "",
            "determiner": cJson.determiner || cJson.determinedByReference || "",
            "valueCodeableConcept": cJson.valueCodeableConcept || "", "valueQuantity": cJson.valueQuantity || "",
            "valueRange": cJson.valueRange || "", "valueReference": cJson.valueReference || "",
            "offset": cJson.offset || "", "valueBoolean": cJson.valueBoolean ?? "",
            "valueExpression": cJson.valueExpression || "", "valueUri": cJson.valueUri || "",
            "exclude": cJson.exclude || false,
            "instancesUnsignedInt": (cJson.instancesUnsignedInt || cJson.instancesUnsignedInt === 0) ? cJson.instancesUnsignedInt : cJson.instancesQuantity?.value || "",
            "instancesRange": cJson.instancesRange || "", "durationDuration": cJson.durationDuration || "",
            "durationRange": cJson.durationRange || "", "timing": cJson.timing || [], "period": cJson.period || ""
        };

        setCharacteristicState(startingCharacteristicState);
        let startingDeterminedByOpenState = false;
        if (startingCharacteristicState.determiner && Object.keys(startingCharacteristicState.determiner).length > 0) {
            startingDeterminedByOpenState = true;
        }
        if (startingCharacteristicState.formula && Object.keys(startingCharacteristicState.formula).length > 0) {
            startingDeterminedByOpenState = true;
        }
        if (cJson.method?.length > 0) {
            startingDeterminedByOpenState = true;
        }
        let startingInstancesDatatype = 'none';
        let startingDurationDatatype = 'none';
        let startingInstancesOpenState = false;
        let startingDurationOpenState = false;
        if (cJson.instancesUnsignedInt || cJson.instancesUnsignedInt === 0 || cJson.instancesQuantity) {
            startingInstancesDatatype = "unsignedInt";
            startingInstancesOpenState = true;
        }
        if (cJson.instancesRange) {
            startingInstancesDatatype = "Range";
            startingInstancesOpenState = true;
        }
        if (cJson.durationDuration) {
            startingDurationDatatype = "Duration";
            startingDurationOpenState = true;
        }
        if (cJson.durationRange) {
            startingDurationDatatype = "Range";
            startingDurationOpenState = true;
        }
        let startingCharacteristicValueDatatype = 'none';
        if (cJson.valueCodeableConcept) {
            startingCharacteristicValueDatatype = "CodeableConcept";
        }
        if (cJson.valueReference) {
            startingCharacteristicValueDatatype = "Reference";
        }
        if (cJson.valueQuantity) {
            startingCharacteristicValueDatatype = "Quantity";
        }
        if (cJson.valueRange) {
            startingCharacteristicValueDatatype = "Range";
        }
        if (typeof cJson.valueBoolean === "boolean") {
            startingCharacteristicValueDatatype = "boolean";
        }
        if (cJson.valueExpression) {
            startingCharacteristicValueDatatype = "Expression";
        }
        if (cJson.valueUri) {
            startingCharacteristicValueDatatype = "uri";
        }
        setDeterminedByOpenState(startingDeterminedByOpenState);
        setCharacteristicValueDatatypeState(startingCharacteristicValueDatatype);
        setInstancesDatatypeState(startingInstancesDatatype);
        setInstancesOpenState(startingInstancesOpenState);
        setDurationDatatypeState(startingDurationDatatype);
        setDurationOpenState(startingDurationOpenState);
    }, []);

    useEffect((() => {
        if (instancesDatatypeState === 'unsignedInt') {
            setCharacteristicState(prevState => { return { ...prevState, 'instancesRange': null } })
        }
        if (instancesDatatypeState === 'Range') {
            setCharacteristicState(prevState => { return { ...prevState, 'instancesUnsignedInt': null } })
        }
    }), [instancesDatatypeState]);

    useEffect((() => {
        if (durationDatatypeState === 'Duration') {
            setCharacteristicState(prevState => { return { ...prevState, 'durationRange': null } })
        }
        if (durationDatatypeState === 'Range') {
            setCharacteristicState(prevState => { return { ...prevState, 'durationDuration': null } })
        }
    }), [durationDatatypeState]);

    useEffect((() => {
        if (characteristicValueDatatypeState === 'CodeableConcept') {
            setCharacteristicState(prevState => {
                return {
                    ...prevState,
                    'valueReference': null, 'valueExpression': null, 'valueQuantity': null,
                    'valueRange': null, 'valueBoolean': null, 'valueUri': null
                }
            })
        }
        if (characteristicValueDatatypeState === 'Reference') {
            setCharacteristicState(prevState => {
                return {
                    ...prevState,
                    'valueExpression': null, 'valueCodeableConcept': null, 'valueQuantity': null,
                    'valueRange': null, 'valueBoolean': null, 'valueUri': null
                }
            })
        }
        if (characteristicValueDatatypeState === 'Expression') {
            setCharacteristicState(prevState => {
                return {
                    ...prevState,
                    'valueReference': null, 'valueCodeableConcept': null, 'valueQuantity': null,
                    'valueRange': null, 'valueBoolean': null, 'valueUri': null
                }
            })
        }
        if (characteristicValueDatatypeState === 'Quantity') {
            setCharacteristicState(prevState => {
                return {
                    ...prevState,
                    'valueReference': null, 'valueExpression': null, 'valueCodeableConcept': null,
                    'valueRange': null, 'valueBoolean': null, 'valueUri': null
                }
            })
        }
        if (characteristicValueDatatypeState === 'Range') {
            setCharacteristicState(prevState => {
                return {
                    ...prevState,
                    'valueReference': null, 'valueExpression': null, 'valueCodeableConcept': null,
                    'valueQuantity': null, 'valueBoolean': null, 'valueUri': null
                }
            })
        }
        if (characteristicValueDatatypeState === 'boolean') {
            setCharacteristicState(prevState => {
                return {
                    ...prevState,
                    'valueReference': null, 'valueExpression': null, 'valueCodeableConcept': null,
                    'valueQuantity': null, 'valueRange': null, 'valueUri': null
                }
            })
        }
        if (characteristicValueDatatypeState === 'uri') {
            setCharacteristicState(prevState => {
                return {
                    ...prevState,
                    'valueReference': null, 'valueExpression': null, 'valueCodeableConcept': null,
                    'valueQuantity': null, 'valueRange': null, 'valueBoolean': null
                }
            })
        }
    }), [characteristicValueDatatypeState]);

    useEffect((() => {
        let typeCode = "";
        if (characteristicState.code) {
            let toBeCharacteristicCodeDisplay = "";
            if (characteristicState.code.coding?.length > 0) {
                if (characteristicState.code.coding[0].code) {
                    typeCode = characteristicState.code.coding[0].code;
                }
                if (characteristicState.code.coding.length === 1) {
                    toBeCharacteristicCodeDisplay = characteristicState.code.coding[0].display || characteristicState.code.coding[0].code;
                } else {
                    toBeCharacteristicCodeDisplay = characteristicState.code.coding.map(coding => { return coding.display || coding.code }).join(", ");
                }
            }
            if (characteristicState.code.text) {
                if (toBeCharacteristicCodeDisplay) {
                    toBeCharacteristicCodeDisplay += ", " + characteristicState.code.text;
                } else {
                    toBeCharacteristicCodeDisplay = characteristicState.code.text;
                }
                if (!typeCode) {
                    typeCode = characteristicState.code.text;
                }
            }
            setCharacteristicCodeDisplay(toBeCharacteristicCodeDisplay);
        }
        if (typeCode && codeableConceptLevelValueSetDictionary[typeCode]) {
            setTypeSpecificCodeableConceptLevelValueSetState(codeableConceptLevelValueSetDictionary[typeCode])
        }
        if (typeCode.toLowerCase() === "defined by codeableconcept") {
            setCharacteristicValueDatatypeState("CodeableConcept");
            setChooseValueDatatypeState(false);
            return;
        } else if (typeCode === "In Group of" || typeCode === "Member of" ||
            typeCode === "Research Study from which this is the observed sample" ||
            typeCode.toLowerCase() === "defined by reference" || typeCode.toLowerCase() === "eligibility criteria") {
            setCharacteristicValueDatatypeState("Reference");
            setChooseValueDatatypeState(false);
            if (typeCode.toLowerCase() === "eligibility criteria" || typeCode === "In Group of" || typeCode === "Member of") {
                setEligibilityCriteriaEntryState(true);
            } else {
                setEligibilityCriteriaEntryState(false);
            }
            return;
        } else if (typeCode.toLowerCase() === "defined by expression") {
            setCharacteristicValueDatatypeState("Expression");
            setChooseValueDatatypeState(false);
            return;
        }
        setChooseValueDatatypeState(true);

        let valuePickList = [
            { key: "codeableConcept", value: "CodeableConcept", text: "Codeable Concept" },
            { key: "reference", value: "Reference", text: "Reference" },
            { key: "quantity", value: "Quantity", text: "Quantity" },
            { key: "range", value: "Range", text: "Range" },
            { key: "boolean", value: "boolean", text: "Boolean" },
            { key: "expression", value: "Expression", text: "Expression" },
            { key: "uri", value: "uri", text: "URI" }
        ];
        if (typeCode === "397669002") {
            valuePickList = [{ key: "codeableConcept", value: "CodeableConcept", text: "Codeable Concept" }, { key: "quantity", value: "Quantity", text: "Quantity" }, { key: "range", value: "Range", text: "Range" }];
            setAgeEntryState(true);
            if (characteristicValueDatatypeState === "none") {
                setCharacteristicValueDatatypeState("Range");
            }
        } else {
            setAgeEntryState(false);
            if (typeCode === "64572001" || typeCode === "103579009" || typeCode === "186034007" || typeCode === "246112005" || typeCode === "260905004" || typeCode === "263495000") {
                valuePickList = [{ key: "codeableConcept", value: "CodeableConcept", text: "Codeable Concept" }, { key: "reference", value: "Reference", text: "Reference" }];
            } else if (typeCode === "Exposure (intervention)" || typeCode === "Medication (exposure or intervention)" || typeCode === "246267002" || typeCode === "305335007") {
                valuePickList = [{ key: "codeableConcept", value: "CodeableConcept", text: "Codeable Concept" }, { key: "reference", value: "Reference", text: "Reference" }, { key: "uri", value: "uri", text: "URI" }];
            } else if (typeCode === "Measurement values") {
                valuePickList = [{ key: "codeableConcept", value: "CodeableConcept", text: "Codeable Concept" }, { key: "expression", value: "Expression", text: "Expression" }];
            }
            if (typeCode === "246267002" || typeCode === "305335007" || typeCode === "Exposure (intervention)" || typeCode === "Medication (exposure or intervention)" || typeCode === "Measurement values") {
                setCharacteristicValueDatatypeState("CodeableConcept");
            }
        }
        setValuePickListState(valuePickList);
        if (codeableConceptLevelValueSetDictionary[typeCode]) {
            setTypeSpecificCodeableConceptLevelValueSetState(codeableConceptLevelValueSetDictionary[typeCode]);
        }
    }), [characteristicState.code]);

    useEffect((() => {
        if (editMode) {
            let newCharacteristic = {};
            if (characteristicState.extension?.length > 0) {
                newCharacteristic.extension = characteristicState.extension;
            }
            if (characteristicState.description) {
                newCharacteristic.description = characteristicState.description;
            }
            if (characteristicState.code) {
                newCharacteristic.code = characteristicState.code;
            }
            if (characteristicState.method?.length > 0) {
                newCharacteristic.method = characteristicState.method;
            }
            if (characteristicState.formula) {
                newCharacteristic.formula = characteristicState.formula;
            }
            if (characteristicState.determiner) {
                newCharacteristic.determiner = characteristicState.determiner;
            }
            if (characteristicState.valueCodeableConcept) {
                newCharacteristic.valueCodeableConcept = characteristicState.valueCodeableConcept;
            }
            if (characteristicState.valueQuantity) {
                newCharacteristic.valueQuantity = characteristicState.valueQuantity;
            }
            if (characteristicState.valueRange) {
                newCharacteristic.valueRange = characteristicState.valueRange;
            }
            if (characteristicState.valueReference) {
                newCharacteristic.valueReference = characteristicState.valueReference;
            }
            if (characteristicState.valueExpression) {
                newCharacteristic.valueExpression = characteristicState.valueExpression;
            }
            if (characteristicState.valueUri) {
                newCharacteristic.valueUri = characteristicState.valueUri;
            }
            if (typeof characteristicState.valueBoolean === "boolean") {
                newCharacteristic.valueBoolean = characteristicState.valueBoolean;
            }
            if (characteristicState.offset) {
                newCharacteristic.offset = characteristicState.offset;
            }
            if (typeof characteristicState.exclude === "boolean") {
                newCharacteristic.exclude = characteristicState.exclude;
            } else {
                newCharacteristic.exclude = false;
            }
            if (characteristicState.instancesUnsignedInt || characteristicState.instancesUnsignedInt === 0) {
                newCharacteristic.instancesUnsignedInt = characteristicState.instancesUnsignedInt;
            }
            if (characteristicState.instancesRange) {
                newCharacteristic.instancesRange = characteristicState.instancesRange;
                if (newCharacteristic.instancesRange.low) {
                    newCharacteristic.instancesRange.low.system = "http://unitsofmeasure.org";
                    newCharacteristic.instancesRange.low.code = "1";
                }
                if (newCharacteristic.instancesRange.high) {
                    newCharacteristic.instancesRange.high.system = "http://unitsofmeasure.org";
                    newCharacteristic.instancesRange.high.code = "1";
                }
            }
            if (characteristicState.durationDuration) {
                newCharacteristic.durationDuration = characteristicState.durationDuration;
            }
            if (characteristicState.durationRange) {
                newCharacteristic.durationRange = characteristicState.durationRange;
            }
            if (characteristicState.timing?.length > 0) {
                newCharacteristic.timing = characteristicState.timing;
            }
            if (characteristicState.period) {
                newCharacteristic.period = characteristicState.period;
            }
            if (newCharacteristic.description || newCharacteristic.code) {
                if (criteriaType.toLowerCase() === "inclusion") {
                    setGroupCharacteristicsState(prevState => {
                        let inclusionCriteria = [...prevState.groupInclusionCharacteristics];
                        inclusionCriteria[index] = newCharacteristic;
                        return { ...prevState, groupInclusionCharacteristics: inclusionCriteria };
                    })
                }
                if (criteriaType.toLowerCase() === "exclusion") {
                    setGroupCharacteristicsState(prevState => {
                        let exclusionCriteria = [...prevState.groupExclusionCharacteristics];
                        exclusionCriteria[index] = newCharacteristic;
                        return { ...prevState, groupExclusionCharacteristics: exclusionCriteria };
                    })
                }
            }
        }
    }), [characteristicState]);

    let rowStyle = {};
    if (characteristic.delete) {
        rowStyle["display"] = "none";
    }

    let hasCharacteristicValueDatatype = false;
    if (characteristicValueDatatypeState && characteristicValueDatatypeState !== "none") {
        hasCharacteristicValueDatatype = true;
    }

    return <>
        {editMode ?
            <>
                <Table.Row className='descriptionRowEdit' key={index + '-description'} style={rowStyle}>
                    <Table.Cell style={{ verticalAlign: "top" }} colSpan="4">
                        <MarkdownEntry elementName='description' fieldLabel='Description (text summary of characteristic)'
                            startingValue={characteristicState.description || null} setResourceState={setCharacteristicState}
                            startCollapsed />
                        {characteristicState.description && <>
                            &nbsp;&nbsp;
                            <Button style={{ width: "240px" }} className="formButton"
                                content="Generate valueCodeableConcept.text"
                                onClick={() => {
                                    setCharacteristicState(prevState => {
                                        return {
                                            ...prevState,
                                            "code": { "text": "Defined by CodeableConcept" },
                                            "valueCodeableConcept": { "text": characteristicState.description }
                                        }
                                    });
                                    setCharacteristicValueDatatypeState("CodeableConcept");
                                }} />
                        </>}
                    </Table.Cell>
                </Table.Row>
                <Table.Row className='detailRow' key={index} style={rowStyle}>
                    <Table.Cell style={{ verticalAlign: "top", align: "center" }}>
                        <div style={{ width: "100%", textAlign: "center", paddingTop: "10px" }}>
                            <DeleteCharacteristicRowButton criteriaType={criteriaType}
                                setGroupCharacteristicsState={setGroupCharacteristicsState}
                                index={index} characteristicString={characteristicCodeDisplay} />
                        </div>
                    </Table.Cell>
                    <Table.Cell style={{ verticalAlign: "top" }}>
                        <CodeableConceptEntry elementName='code' fieldLabel='Characteristic Type'
                            startingValue={characteristicState.code || null} setResourceState={setCharacteristicState}
                            codeableConceptLevelValueSet={codeableConceptLevelValueSet}
                            systemChoices={valueCodeableConceptSystemChoices} systemChoicesOpen={true}
                            startCollapsed inTableCell={true} />
                        <br />
                        {determinedByOpenState ?
                            <>
                                <ArrayEntry datatype='CodeableConcept' elementName='method' fieldLabel='Method'
                                    startingValue={characteristicState.method || []} setResourceState={setCharacteristicState}
                                    startCollapsed inTableCell={true} />
                                <br />
                                <ReferenceEntry elementName='determiner' fieldLabel='Determiner'
                                    referencedResourceTypes={characteristicDotDeterminerReferenceResourceTypes} inTableCell={true}
                                    startingValue={characteristicState.determiner || null} setResourceState={setCharacteristicState} />
                                <ExpressionEntry elementName='formula' fieldLabel='Formula'
                                    startingValue={characteristicState.formula || null} setResourceState={setCharacteristicState}
                                    inTableCell={true} />
                            </>
                            :
                            <span className={"unselectable"} style={{ color: "#70BDEB", cursor: "pointer" }}
                                onClick={() => { setDeterminedByOpenState(true); }} ><i>Click to add method/formula/determiner data.</i></span>
                        }
                        <div style={{ margin: "8px" }}></div>
                    </Table.Cell>
                    <Table.Cell style={{ verticalAlign: "top" }}>
                        {(characteristicState.code?.text === "Eligibility Criteria" &&
                            !(characteristicState.valueReference?.reference || characteristicState.valueReference?.identifier)
                        ) &&
                            <GroupCriteriaConverter startingEligibilityCriteria={characteristicState.valueReference?.display ||
                                characteristicState.valueCodeableConcept?.text}
                                setGroupCharacteristicState={setCharacteristicArrayState} />}
                        {chooseValueDataTypeState && <>
                            <Dropdown
                                name="characteristicvaluetype"
                                placeholder="Characteristic Value Type"
                                closeOnChange selection selectOnBlur={false} autoComplete="off"
                                style={{ minWidth: "50%", width: "100%" }}
                                options={valuePickListState}
                                value={characteristicValueDatatypeState}
                                onChange={(e, data) => {
                                    if (characteristicState.valueCodeableConcept || characteristicState.valueExpression ||
                                        characteristicState.valueUri || characteristicState.valueReference ||
                                        characteristicState.valueRange || characteristicState.valueQuantity ||
                                        typeof characteristicState.valueBoolean === "boolean") {
                                        alert("You switched datatypes, so previously entered data was lost for this characteristic value.");
                                    }
                                    setCharacteristicValueDatatypeState(data.value);
                                }}
                            />&nbsp;&nbsp;
                            {hasCharacteristicValueDatatype ?
                                <span style={{ color: "#828282" }}><i>Change Value Datatype</i></span>
                                :
                                <span style={{ color: "#828282" }}><i>Select Value Datatype</i></span>
                            }
                            <div style={{ margin: "12px" }}></div>
                        </>}
                        {characteristicValueDatatypeState === "CodeableConcept" &&
                            <CodeableConceptEntry elementName='valueCodeableConcept' fieldLabel='Characteristic Value'
                                startingValue={characteristicState.valueCodeableConcept || null} setResourceState={setCharacteristicState}
                                codeableConceptLevelValueSet={typeSpecificCodeableConceptLevelValueSetState}
                                systemChoices={systemChoicesState} setSystemChoices={setSystemChoicesState} systemChoicesOpen={true} inTableCell={true}
                                startCollapsed={!hasCharacteristicValueDatatype} />
                        }
                        {characteristicValueDatatypeState === "Reference" &&
                            <ReferenceEntry elementName='valueReference' fieldLabel='Characteristic Value'
                                startingValue={characteristicState.valueReference || null} setResourceState={setCharacteristicState}
                                startingResourceType={eligibilityCriteriaEntryState ? "Group" : null}
                                referencedResourceTypes={eligibilityCriteriaEntryState ? ["Group"] : null}
                                enableCreation={true} inTableCell={true} startCollapsed={!hasCharacteristicValueDatatype} />
                        }
                        {characteristicValueDatatypeState === "Quantity" &&
                            <QuantityEntry elementName='valueQuantity' fieldLabel='Characteristic Value'
                                startingValue={characteristicState.valueQuantity || null} setResourceState={setCharacteristicState}
                                inTableCell={true} valueSet="UCUM" dataEntryStyle={ageEntryState ? "Age" : ""}
                                startCollapsed={!hasCharacteristicValueDatatype} />
                        }
                        {characteristicValueDatatypeState === "Range" &&
                            <RangeEntry elementName='valueRange' fieldLabel='Characteristic Value'
                                startingValue={characteristicState.valueRange || null} setResourceState={setCharacteristicState}
                                inTableCell={true} valueSet="UCUM" dataEntryStyle={ageEntryState ? "Age" : ""}
                                startCollapsed={!hasCharacteristicValueDatatype} />
                        }
                        {characteristicValueDatatypeState === "boolean" &&
                            <BooleanEntry elementName='valueBoolean' fieldLabel='Characteristic Value'
                                startingValue={characteristicState.valueBoolean ?? null} setResourceState={setCharacteristicState}
                                storeFalse={true} inTableCell={true} />
                        }
                        {characteristicValueDatatypeState === "Expression" &&
                            <ExpressionEntry elementName='valueExpression' fieldLabel='Characteristic Value'
                                startingValue={characteristicState.valueExpression || null} setResourceState={setCharacteristicState}
                                inTableCell={true}
                                startCollapsed={!hasCharacteristicValueDatatype} />
                        }
                        {characteristicValueDatatypeState === "uri" &&
                            <UriEntry elementName='valueUri' fieldLabel='Characteristic Value'
                                startingValue={characteristicState.valueUri || null} setResourceState={setCharacteristicState} inTableCell={true} />}
                        <div style={{ paddingTop: "8px" }} />
                        <CodeableConceptEntry elementName='offset' fieldLabel='Offset'
                            startingValue={characteristicState.offset || null} setResourceState={setCharacteristicState}
                            valueSet={characteristicOffsetValueSet} inTableCell={false} startCollapsed />
                        <br />
                        {instancesOpenState ?
                            <>
                                <DatatypeSelector elementXName='instances[x]' allowedDatatypes={characteristicDotInstancesAllowedDatatypes}
                                    datatypeState={instancesDatatypeState} setDatatypeState={setInstancesDatatypeState} inTableCell={true} />
                                {(instancesDatatypeState === 'unsignedInt') &&
                                    <UnsignedIntEntry elementName='instancesUnsignedInt' fieldLabel='Number of Times Criteria Met'
                                        startingValue={characteristicState.instancesUnsignedInt} setResourceState={setCharacteristicState} inTableCell={true} />}
                                {(instancesDatatypeState === 'Range') &&
                                    <RangeEntry elementName='instancesRange' fieldLabel='Number of Times Criteria Met'
                                        startingValue={characteristicState.instancesRange || null} setResourceState={setCharacteristicState} inTableCell={true} />}
                            </>
                            :
                            <span className={"unselectable"} style={{ color: "#70BDEB", cursor: "pointer" }}
                                onClick={() => { setInstancesOpenState(true); }} ><i>Click to add number of instances.</i></span>
                        }
                        <br />
                        {durationOpenState ?
                            <>
                                <DatatypeSelector elementXName='duration[x]' allowedDatatypes={characteristicDotDurationAllowedDatatypes}
                                    datatypeState={durationDatatypeState} setDatatypeState={setDurationDatatypeState} inTableCell={true} />
                                {(durationDatatypeState === 'Duration') &&
                                    <QuantityEntry elementName='durationDuration'
                                        fieldLabel='Length of Time Meeting Criteria'
                                        startingValue={characteristicState.durationDuration || null}
                                        setResourceState={setCharacteristicState} inTableCell={true}
                                        dataEntryStyle={"Duration"} />}
                                {(durationDatatypeState === 'Range') &&
                                    <RangeEntry elementName='durationRange' fieldLabel='Length of Time Meeting Criteria'
                                        dataEntryStyle="Duration"
                                        startingValue={characteristicState.durationRange || null} setResourceState={setCharacteristicState} inTableCell={true} />}
                            </>
                            :
                            <span className={"unselectable"} style={{ color: "#70BDEB", cursor: "pointer" }}
                                onClick={() => { setDurationOpenState(true); }} ><i>Click to add duration meeting criteria.</i></span>
                        }
                    </Table.Cell>
                    <Table.Cell style={{ verticalAlign: "top" }}>
                        <div>
                            {relativeTimeModalState.modalOpen &&
                                <RelativeTimeModal startingValue={characteristicState.timing || null}
                                    setCharacteristicState={setCharacteristicState}
                                    relativeTimeModalState={relativeTimeModalState}
                                    setRelativeTimeModalState={setRelativeTimeModalState} />}
                            {characteristicState.timing?.length > 0 && <div>
                                <>{characteristicState.timing.map(timing => {
                                    return displayStringFromFHIRRelativeTime(timing)
                                }).join("; ")}</>
                                <br />
                            </div>}
                            <Button style={{ width: "120px" }} className="formButton"
                                content="Add/Edit Timing"
                                onClick={() => {
                                    setRelativeTimeModalState(prevState => { return { ...prevState, "modalOpen": true } });
                                }} />
                        </div>
                        <br />
                        <PeriodEntry elementName='period' fieldLabel='Period' startCollapsed inTableCell={true}
                            startingValue={characteristicState.period || null} setResourceState={setCharacteristicState} />
                    </Table.Cell>
                </Table.Row>
            </>
            :
            <>
                <Table.Row className='detailRow' key={index} style={rowStyle}>
                    <Table.Cell style={{ verticalAlign: "top" }}>
                        {characteristicCodeDisplay}
                        {methodDisplay && <><br /><b>Method: </b>{methodDisplay}</>}
                        {characteristicForumlaDisplay && <><br /><b>Calculated by: </b>{characteristicForumlaDisplay}</>}
                        {characteristicDeterminerDisplay && <><br /><b>Determined by: </b>{characteristicDeterminerDisplay}</>}
                    </Table.Cell>
                    <Table.Cell style={{ verticalAlign: "top" }}>
                        {characteristicState.valueCodeableConcept && <DisplayFromFHIRCodeableConcept codeableConcept={characteristicState.valueCodeableConcept} />}
                        {characteristicState.valueQuantity && displayStringFromFHIRQuantity(characteristicState.valueQuantity)}
                        {characteristicState.valueRange && displayStringFromFHIRRange(characteristicState.valueRange)}
                        {typeof characteristicState.valueBoolean === "boolean" && displayStringFromFHIRBoolean(characteristicState.valueBoolean)}
                        {characteristicState.valueReference && <DisplayFromFHIRReference reference={characteristicState.valueReference} />}
                        {characteristicState.valueExpression && <DisplayFromFHIRExpression expression={characteristicState.valueExpression} />}
                        {characteristicState.valueUri && <DisplayFromFHIRUri uri={characteristicState.valueUri} />}
                        {characteristicState.offset && <>
                            <br /><b>Offset: </b><DisplayFromFHIRCodeableConcept codeableConcept={characteristicState.offset} />
                        </>}
                        {(characteristicState.instancesUnsignedInt || characteristicState.instancesUnsignedInt === 0) && <><br />
                            <b>Number of instances meeting criteria: </b>{characteristicState.instancesUnsignedInt}</>}
                        {characteristicState.instancesQuantity && <><br />
                            <b>Number of instances meeting criteria: </b>{displayStringFromFHIRQuantity(characteristicState.instancesQuantity)}</>}
                        {characteristicState.instancesRange && <><br />
                            <b>Number of instances meeting criteria: </b>{displayStringFromFHIRRange(characteristicState.instancesRange)}</>}
                        {characteristicState.durationDuration && <><br />
                            <b>Duration meeting criteria: </b>{displayStringFromFHIRQuantity(characteristicState.durationDuration)}</>}
                        {characteristicState.durationRange && <><br />
                            <b>Duration meeting criteria: </b>{displayStringFromFHIRRange(characteristicState.durationRange)}</>}
                    </Table.Cell>
                    <Table.Cell style={{ verticalAlign: "top" }}>
                        {characteristicState.timing?.length > 0 && characteristicState.timing.map(timing => {
                            return displayStringFromFHIRRelativeTime(timing)
                        }).join("; ")}
                        {(characteristicState.timing?.length > 0 && characteristicState.period) && <br />}
                        {characteristicState.period && <>{displayStringFromFHIRPeriod(characteristicState.period)}</>}
                    </Table.Cell>
                </Table.Row>
                <Table.Row className='descriptionRow' key={index + '-description'} style={rowStyle}>
                    <Table.Cell style={{ verticalAlign: "top" }} colSpan="3">
                        <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Description: </b><DisplayFromFHIRMarkdown markdown={characteristicState.description} /></>
                    </Table.Cell>
                </Table.Row>
            </>
        }
    </>
}

const EnhancedCharacteristicsTable = ({ criteriaType, editMode, smallCriteriaHeader, groupCriteriaCharacteristics,
    setGroupCharacteristicsState, setCharacteristicArrayState }) => {

    let headerCellColor = "#F9FAFB";
    let h3Color = "#000000";
    if (criteriaType.toLowerCase() === "inclusion") {
        headerCellColor = "#EAFCEA";
        h3Color = "#006800";
    } else if (criteriaType.toLowerCase() === "exclusion") {
        headerCellColor = "#FCEAEA";
        h3Color = "#680000";
    }

    return <>
        {smallCriteriaHeader === false && <h3 id={criteriaType.toLowerCase() + "-criteria"}
            style={{ marginTop: "0px", color: h3Color }}>{criteriaType} Criteria</h3>}
        <div style={{ marginLeft: "24px" }}>
            {groupCriteriaCharacteristics?.length > 0 ? <>
                {smallCriteriaHeader && <b>{criteriaType} Criteria</b>}
                <Table className='enhancedCharacteristicsTable' style={{ margin: "0px" }} >
                    <Table.Header>
                        <Table.Row>
                            {editMode && <Table.HeaderCell>Delete</Table.HeaderCell>}
                            <Table.HeaderCell style={{ width: "30%", backgroundColor: headerCellColor }}>Type of Characteristic</Table.HeaderCell>
                            <Table.HeaderCell style={{ width: "50%", backgroundColor: headerCellColor }}>Characteristic Value</Table.HeaderCell>
                            <Table.HeaderCell style={{ width: "20%", backgroundColor: headerCellColor }}>Timing</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {groupCriteriaCharacteristics.map((characteristic, index) => {
                            return <EnhancedCharacteristicTableRow key={index} characteristic={characteristic} index={index}
                                setGroupCharacteristicsState={setGroupCharacteristicsState}
                                criteriaType={criteriaType} editMode={editMode}
                                setCharacteristicArrayState={setCharacteristicArrayState} />
                        })
                        }
                    </Table.Body>
                </Table>
            </>
                :
                <>No {criteriaType.toLowerCase()} criteria.</>}
            {smallCriteriaHeader === false &&
                <span>
                    {editMode && <>
                        <Button className="formButton" style={{ color: "#000000" }}
                            content={"+ Add " + criteriaType + " Criteria"}
                            onClick={() => {
                                if (criteriaType.toLowerCase() === "inclusion") {
                                    setGroupCharacteristicsState(prevState => {
                                        let inclusionCriteria = [...prevState.groupInclusionCharacteristics];
                                        inclusionCriteria.push({ "exclude": false });
                                        return { ...prevState, groupInclusionCharacteristics: inclusionCriteria };
                                    })
                                }
                                if (criteriaType.toLowerCase() === "exclusion") {
                                    setGroupCharacteristicsState(prevState => {
                                        let exclusionCriteria = [...prevState.groupExclusionCharacteristics];
                                        exclusionCriteria.push({ "exclude": true });
                                        return { ...prevState, groupExclusionCharacteristics: exclusionCriteria };
                                    })
                                }
                            }} />
                    </>}
                    <br />
                </span>
            }
        </div>
    </>
}

const InclusionExclusionEnhancedCharacteristicTables = ({ editMode, smallCriteriaHeader,
    groupInclusionCharacteristics, groupExclusionCharacteristics, setGroupCharacteristicsState,
    setCharacteristicArrayState }) => {
    return <>
        <EnhancedCharacteristicsTable criteriaType={"Inclusion"} editMode={editMode}
            smallCriteriaHeader={smallCriteriaHeader}
            groupCriteriaCharacteristics={groupInclusionCharacteristics}
            setGroupCharacteristicsState={setGroupCharacteristicsState}
            setCharacteristicArrayState={setCharacteristicArrayState} />
        <br />
        <EnhancedCharacteristicsTable criteriaType={"Exclusion"} editMode={editMode}
            smallCriteriaHeader={smallCriteriaHeader}
            groupCriteriaCharacteristics={groupExclusionCharacteristics}
            setGroupCharacteristicsState={setGroupCharacteristicsState}
            setCharacteristicArrayState={setCharacteristicArrayState} />
    </>
}

const ManageInclusionExclusionEnhancedCharacteristicTables = ({ fhirJson, editMode, setResourceState }) => {

    const [characteristicArrayState, setCharacteristicArrayState] = useState(null);

    const [groupCharacteristicsState, setGroupCharacteristicsState] = useState({
        "resourceJson": fhirJson,
        "groupExclusionCharacteristics": [],
        "groupInclusionCharacteristics": []
    });

    useEffect(() => {
        if (fhirJson?.characteristic) {
            setCharacteristicArrayState(fhirJson.characteristic);
            let groupInclusionCharacteristics = [];
            let groupExclusionCharacteristics = [];
            if (fhirJson?.characteristic?.length > 0) {
                for (const characteristic of fhirJson.characteristic) {
                    if (characteristic?.description || characteristic?.code) {
                        if (characteristic.exclude) {
                            groupExclusionCharacteristics.push(characteristic);
                        } else {
                            groupInclusionCharacteristics.push(characteristic);
                        }
                    }
                }
            }
            setGroupCharacteristicsState(prevState => {
                return {
                    ...prevState,
                    "groupExclusionCharacteristics": groupExclusionCharacteristics,
                    "groupInclusionCharacteristics": groupInclusionCharacteristics
                }
            })
        }
    }, []);

    useEffect(() => {
        let groupInclusionCharacteristics = [];
        let groupExclusionCharacteristics = [];
        if (characteristicArrayState?.length > 0) {
            for (const characteristic of characteristicArrayState) {
                if (characteristic?.description || characteristic?.code) {
                    if (characteristic.exclude) {
                        groupExclusionCharacteristics.push(characteristic);
                    } else {
                        groupInclusionCharacteristics.push(characteristic);
                    }
                }
            }
        }
        setGroupCharacteristicsState(prevState => {
            return {
                ...prevState,
                "groupExclusionCharacteristics": groupExclusionCharacteristics,
                "groupInclusionCharacteristics": groupInclusionCharacteristics
            }
        })
    }, [characteristicArrayState])

    useEffect(() => {
        if (setResourceState && (groupCharacteristicsState.groupInclusionCharacteristics.length ||
            groupCharacteristicsState.groupExclusionCharacteristics.length)) {
            let inclusionCriteria = [];
            let exclusionCriteria = [];
            if (groupCharacteristicsState.groupInclusionCharacteristics) {
                inclusionCriteria = JSON.parse(JSON.stringify(groupCharacteristicsState.groupInclusionCharacteristics));
            }
            if (groupCharacteristicsState.groupExclusionCharacteristics) {
                exclusionCriteria = JSON.parse(JSON.stringify(groupCharacteristicsState.groupExclusionCharacteristics));
            }
            let newCharacteristic = inclusionCriteria.concat(exclusionCriteria);
            setResourceState(prevState => { return { ...prevState, "characteristic": newCharacteristic } });
        }
    }, [groupCharacteristicsState]);

    return <>
        {characteristicArrayState &&
            <>
                {(editMode && characteristicArrayState.length === 0) &&
                    <GroupCriteriaStarter setGroupCharacteristicState={setCharacteristicArrayState} />}
                {groupCharacteristicsState &&
                    <InclusionExclusionEnhancedCharacteristicTables editMode={editMode}
                        smallCriteriaHeader={false} groupInclusionCharacteristics={groupCharacteristicsState.groupInclusionCharacteristics}
                        groupExclusionCharacteristics={groupCharacteristicsState.groupExclusionCharacteristics}
                        setGroupCharacteristicsState={setGroupCharacteristicsState}
                        setCharacteristicArrayState={setCharacteristicArrayState} />
                }
            </>}
    </>
}

const GroupResourceEdit = ({ foi }) => {

    const dispatch = useDispatch();
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    const [editResourceState, setEditResourceState] = useState({
        text: resourceJson.text,
        title: resourceJson.title,
        name: resourceJson.name,
        description: resourceJson.description,
        membership: resourceJson.membership,
        quantity: resourceJson.quantity,
        type: resourceJson.type,
        combinationMethod: resourceJson.combinationMethod,
        combinationThreshold: resourceJson.combinationThreshold,
        characteristic: resourceJson.characteristic || []
    });

    useEffect(() => {
        if (resourceJson) {
            updateNarrativeElement(editResourceState, "text", "Narrative", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.text]);

    useEffect(() => {
        if (editResourceState) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = editResourceState.title;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.title !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.title)) {
                console.log("resourceUpdate for Group.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "title",
                    previousInitialValue,
                    editResourceState.title);
            }
        }
    }, [editResourceState.title]);

    useEffect(() => {
        if (editResourceState) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.name;
            previousFinalValue = newResourceDetail.revisedResourceJson.name;
            newResourceDetail.revisedResourceJson.name = editResourceState.name;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.name !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.name)) {
                console.log("resourceUpdate for Group.name");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "name",
                    previousInitialValue,
                    editResourceState.name);
            }
        }
    }, [editResourceState.name]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "description", "markdown", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.description]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "membership", "code", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.membership]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "quantity", "unsignedInt", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.quantity]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "type", "code", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.type]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "combinationMethod", "code", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.combinationMethod]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "combinationThreshold", "positiveInt", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.combinationThreshold]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "characteristic", "ArrayOfGroupCharacteristic", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.characteristic]);

    return <div>
        {editResourceState && <>
            <StringEntry elementName='title'
                fieldLabel={'Title (Label for the Group)'}
                startingValue={editResourceState.title || ""}
                required={(editResourceState.description || editResourceState.quantity || editResourceState.combinationMethod || editResourceState.combinationThreshold || editResourceState.characteristic)}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='name' fieldLabel='Name (Label for the Group)'
                startingValue={editResourceState.name || ""} setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel={'Group Description'}
                startingValue={editResourceState.description || ""} setResourceState={setEditResourceState} />
            <p>Select a Membership code for this Group. Choose 'enumerated' if you will report a quantity for the Group or if you will report or reference the Group members. Choose 'definitional' if you will report the characteristics defining membership in the Group and will select a Type code specifying the type of Group members in a FHIR context. Choose 'conceptual' if you are not reporting an enumerated or definitional Group, or if you are reporting a Group without a Type code.</p>
            <CodeEntry elementName='membership' fieldLabel='Membership'
                allowedValues={['conceptual', 'definitional', 'enumerated']}
                startingValue={editResourceState.membership || ""} setResourceState={setEditResourceState} />
            <UnsignedIntEntry elementName='quantity' fieldLabel={'Number of Members'}
                startingValue={editResourceState.quantity || ""} setResourceState={setEditResourceState} />
            <p>Narrative Summary</p>
            <div style={{ marginLeft: "24px" }}>
                <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                    generatedNarrative={generateNarrativeForGroupResource(resourceJson)} startCollapsed
                    startingValue={editResourceState.text} setResourceState={setEditResourceState} />
            </div>
            <CodeEntry elementName='type' fieldLabel='Type'
                allowedValues={['person', 'animal', 'practitioner', 'device', 'careteam', 'healthcareservice', 'location', 'organization', 'relatedperson', 'specimen', 'medication', 'substance', 'biologicallyDerivedProduct', 'nutritionProduct']}
                startingValue={editResourceState.type || ""} setResourceState={setEditResourceState} />
            <CodeEntry elementName='combinationMethod'
                fieldLabel={'Criteria Combination Method'}
                allowedValues={['all-of', 'any-of', 'at-least', 'at-most', 'except-subset']}
                startingValue={editResourceState.combinationMethod || ""} setResourceState={setEditResourceState} />
            {(editResourceState.combinationMethod === "at-least" ||
                editResourceState.combinationMethod === "at-most" ||
                editResourceState.combinationThreshold) &&
                <PositiveIntEntry elementName='combinationThreshold' fieldLabel='Number of characteristics'
                    startingValue={editResourceState.combinationThreshold || ""} setResourceState={setEditResourceState} />}
            <br />
            <ManageInclusionExclusionEnhancedCharacteristicTables editMode={true}
                fhirJson={editResourceState} setResourceState={setEditResourceState} />
            <br />
        </>}
    </div>
}

export default GroupResourceEdit;
export { ManageInclusionExclusionEnhancedCharacteristicTables };